import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IApisVerifyUsernameResponse } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { JsonType } from '@intigral/types';

export interface IVerifyUsernameUseCase {
    execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IApisVerifyUsernameResponse['data']>;
}

export class VerifyUsernameUseCase implements IVerifyUsernameUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IApisVerifyUsernameResponse['data']> {
        const response = await this.authRepo.verifyUsername(username, lang, apiToken, recaptchaToken);
        return response.data;
    }
}
